import Entity, { fetchArray } from "entity";
import { ValidatorHelper } from "functions";


export default class Nascimento extends Entity {
    static get collectionUID() {
        return "Nascimento";
    }

    static get getInitialValues() {
        return { statusBezerro: "ATIVO", data: new Date() }
    }
    async initialize() {
        this.data.status = "ATIVO";
        this.data.data = new Date();

    }

    static async onQuery(collection) {
        return collection.orderBy("data", 'desc');
    }

    static get searchColumns() {
        return [
            { field: "fazenda.nome", headerName: "Fazenda", flex: 4, filter: true, },
            { field: "matriz.numero", headerName: "Nº Matriz", flex: 1, filter: true },
            { field: "numBezerro", headerName: "Nº Bezerro", flex: 1.1, filter: true },
            { field: "statusBezerro", headerName: "Status", flex: 1, filter: true },
            { field: "obsParto", headerName: "Observação", flex: 3, },
            { field: "data", headerName: "Data", flex: 2, filter: true, type: 'date', },
        ]
    }
    static async validFieldErrors(values) {
        //fazendo
        console.log('values', values)
        let v = new ValidatorHelper();

        v.addRequired("fazenda", "Fazenda")
        v.addRequired("matriz.numero", "numero da matriz")
        v.addRequired("matriz.raca", "raça da matriz")

        v.addRequired("data", "data de nascimento")

        if (values.statusBezerro !== "ABORTO" && values.statusBezerro !== "NATIMORTO") {
            console.log(values.statusBezerro)
            v.addRequired("numBezerro", "número do bezerro")
        }

        v.addRequired("sexo", "sexo do bezerro")
        v.addRequired("raca", "bezerro")
        v.addRequired("statusBezerro", "status do bezerro")

        let errorsMessage = v.valid(values);

        if (errorsMessage.length) {
            return errorsMessage
        }

        let ignoreUids = null
        if (values.uid) {
            ignoreUids = []
            ignoreUids.push(values.uid)
            if (values.gemelar?.uid) {
                ignoreUids.push(values.gemelar?.uid)
            }
        }
        console.log('ignoreUids', ignoreUids)
        //Verifica Duplicar Bezerro na Fazenda   
        let q = await Nascimento.collection
            .where("fazenda.uid", "==", values.fazenda.uid)
            .where("numBezerro", "==", values.numBezerro);
        if (ignoreUids)
            q = q.where("uid", 'not-in', ignoreUids)
        let nascimentosBez = await fetchArray(q.get());

        if (nascimentosBez.length) {
            errorsMessage.push("Já existe um nascimento com esse Número de bezzero")
            return errorsMessage
        }

        //Nastimento tem menos de x dias

        let dias = 200;
        let query1 = await Nascimento.collection
            .where("fazenda.uid", "==", values.fazenda.uid)
            .where("matriz.numero", "==", values.matriz.numero);
        if (ignoreUids)
            query1 = query1.where("uid", 'not-in', ignoreUids)
        let nascimentosMatriz = await fetchArray(query1.get());

        console.log('nascimentosMatriz', nascimentosMatriz)
        //Nastimento tem menos de x dias
        let dateAux = new Date()
        dateAux.setDate(dateAux.getDate() - dias)
        for (let index = 0; index < nascimentosMatriz.length; index++) {
            const nascimento = nascimentosMatriz[index];
            let dataN = nascimento.data.toDate();

            if (dataN >= dateAux) {
                errorsMessage.push("Matriz com nascimento nos últimos " + dias + " dias")
                return errorsMessage
            }
        }

        if (errorsMessage.length) {
            return errorsMessage
        }

        return null
    }

}
